<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">消费记录</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div>
                <mt-navbar class="page-part" v-model="selected">
                    <mt-tab-item id="1">全部</mt-tab-item>
                    <mt-tab-item id="2">消费</mt-tab-item>
                    <mt-tab-item id="3">充值</mt-tab-item>
                    <mt-tab-item id="4">退款</mt-tab-item>
                    <mt-tab-item id="5">待付款</mt-tab-item>
                </mt-navbar>
                <mt-tab-container v-model="selected">
                    <mt-tab-container-item id="1">
                        <ul class="all">
                            <li v-for="(value,index) in filterSelectedCardList" :key="index" @click="goOrderDetailsPage(index)">
                                <span>{{ value.moneyTotal.toFixed(2) }}</span>
                                <span>{{ value.ordertime | moment('YYYY年MM月DD日') }}</span>
                                <span>{{ value.ordertime | moment('HH:mm') }}</span>
                                <span :style="(value.status == 0) ? 'color: red' : ''">{{ orderTypeStatus(value.type, value.status) }}</span>
                                <span class="iconfont icon-i-info info-custom"></span>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="2">
                        <ul class="consumption">
                            <li v-for="(value,index) in filterSelectedCardList" :key="index" @click="goOrderDetailsPage(index)">
                                <span>{{ value.moneyTotal.toFixed(2) }}</span>
                                <span>{{ value.ordertime | moment('YYYY年MM月DD日') }}</span>
                                <span>{{ value.ordertime | moment('HH:mm') }}</span>
                                <span :style="(value.status == 0) ? 'color: red' : ''">{{ orderTypeStatus(value.type, value.status) }}</span>
                                <span class="iconfont icon-i-info info-custom"></span>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="3">
                        <ul class="charge">
                            <li v-for="(value,index) in filterSelectedCardList" :key="index" @click="goOrderDetailsPage(index)">
                                <span>{{ value.moneyTotal.toFixed(2) }}</span>
                                <span>{{ value.ordertime | moment('YYYY年MM月DD日') }}</span>
                                <span>{{ value.ordertime | moment('HH:mm') }}</span>
                                <span :style="(value.status == 0) ? 'color: red' : ''">{{ orderTypeStatus(value.type, value.status) }}</span>
                                <span class="iconfont icon-i-info info-custom"></span>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="4">
                        <ul class="refund">
                            <li v-for="(value,index) in filterSelectedCardList" :key="index" @click="goOrderDetailsPage(index)">
                                <span>{{ value.moneyTotal.toFixed(2) }}</span>
                                <span>{{ value.ordertime | moment('YYYY年MM月DD日') }}</span>
                                <span>{{ value.ordertime | moment('HH:mm') }}</span>
                                <span :style="(value.status == 0) ? 'color: red' : ''">{{ orderTypeStatus(value.type, value.status) }}</span>
                                <span class="iconfont icon-i-info info-custom"></span>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="5">
                        <ul class="unpaid">
                            <li v-for="(value,index) in filterSelectedCardList" :key="index" @click="goOrderDetailsPage(index)">
                                <span>{{ value.moneyTotal.toFixed(2) }}</span>
                                <span>{{ value.ordertime | moment('YYYY年MM月DD日') }}</span>
                                <span>{{ value.ordertime | moment('HH:mm') }}</span>
                                <span :style="(value.status == 0) ? 'color: red' : ''">{{ orderTypeStatus(value.type, value.status) }}</span>
                                <span class="iconfont icon-i-info info-custom"></span>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom";
import { DatetimePicker, Popup, Toast, Indicator, Radio, Navbar, TabItem } from "mint-ui";
import { showOrderListAction } from '../../assets/js/api'

export default {
    data() {
        return {  
            isFront:false, 
            isVip:false,
            haveRead:false,
            selected:'1',
            beginIdx:0,            // 分页开始值
            num:0,                 // 分页次数
            loading:true,          // 是否加载 
            cardOrderList:[],      // 会员卡历史订单信息 
            haveData:false,        // 是否有数据
            sid: 0,
            typeStatus: {
                "" : ["全部"],
                "12" : ["消费", "消费成功"],
                "11" : ["充值", "充值成功"],
                "13" : ["退款", "退款成功"],
                "0" : ["待付款", "待付款"],
            },
        };
    },
    computed: {
        filterSelectedCardList: function () {
            let filterString = ''
            if (this.selected == '2') {
                filterString = '12'
            } else if (this.selected == '3') {
                filterString = '11'
            } else if (this.selected == '4') {
                filterString = '13'
            } else if (this.selected == '5') {
                filterString = '0'
            }
            if (this.selected == '1') {
                return this.cardOrderList
            } else {
                let filterCardList = []
                this.cardOrderList.forEach(element => {
                    let checkNumStr = '' + element.status + element.type
                    if (checkNumStr.startsWith('0')) {
                        checkNumStr = '0'
                    }
                    if (filterString === checkNumStr) {
                        filterCardList.push(element)
                    }
                })
                // this.haveData1 = (filterCardList.length > 0)
                return filterCardList
            }
        },
    },
    components: {},
    methods: {

        orderTypeStatus: function (type, status) {
            // 'type' 1:充值订单 2:消费订单 3:退款订单 4:赊账订单
            // 'status' 0：未支付；1：支付完成
            let checkNumStr = '' + status + type
            let statusText = ''
            if (checkNumStr.startsWith('0')) {
                checkNumStr = '0'
            }
            if (this.typeStatus[checkNumStr] && (this.typeStatus[checkNumStr]).length > 1) {
                statusText = this.typeStatus[checkNumStr][1]
            }
            return statusText
        },
        // 跳转到订单详情页
        goOrderDetailsPage(index)
        {
            this.$router.push({ name:"consumeDetail" });
            // var cardInfo = this.cardOrderList[index];
            // cardInfo.sid = this.$store.state.selectedCardInfo.sid;
            // this.$store.commit("selectedOrderInfo",cardInfo);
            // var type     = cardInfo.orderStatus;
            // console.log('type',type);
            // if (type == 1)
            // {
            //     console.log('jinlaile');
            //     this.$router.push({ name:"payDetail" });
            // }
            
        },
        loadMore()
        {
            console.log('haohoahaohoa');
            this.getCardOrderList();
        },
        //获取单张卡的订单记录
        getCardOrderList()
        {
            showOrderListAction(this.sid).then(res => {
                console.log('res111',res);
                if (res.s == 0)
                {             
                    if (this.cardOrderList)
                    {
                        // 存入新获取的商品列表数据
                        res.list.forEach((v,i)=> { this.cardOrderList.push(v); })
                    }
                    else
                    {
                        this.cardOrderList = res.list;
                    }

                    this.$store.commit("cardOrderListInfo",this.cardOrderList);

                    //this.messageList = res.MessageList;
                    console.log("cardOrderList",this.cardOrderList);
                }
                else if (res.s == 1010)
                {
                    this.loading = true;
                    if (this.cardOrderList.length == 0)
                    {
                        this.haveData = false;
                    }
                }
            });
        }         
    },
    created() {
        this.sid = this.$route.query.sid;
    },
    mounted()
    {
        this.getCardOrderList();
    }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.mint-navbar .mint-tab-item{
    border-bottom: 0.01rem solid rgba(153, 153, 153, 0.5);
    margin-bottom: -0.05rem;
    z-index: 2;
}
.mint-navbar .mint-tab-item.is-selected{
    border-bottom: 0.05rem solid #FF5252;
    color: #FF5252;
    margin-bottom: -0.05rem;
}
.mint-tab-container-item{
    background-color: #fff;
    margin-top: 0.01rem;
    z-index: 1;
}
.content {
  position: absolute;
  flex: 1;
  /* background-color: rgba(241, 241, 241, 1); */
  height: auto;
  width: 100%;
}
.page-part{
    font-size: 0.42rem;
    font-weight: 600;
    color: rgba(153, 153, 153, 1);
}
.all li,
.consumption li,
.charge li,
.refund li,
.unpaid li{
    background-color: #fff;
    height: 1.42rem;
    width: 100%;
    border-top: 0.03rem solid rgba(0, 0, 0, 0.1);
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    position: relative;
}
.all li :nth-child(1),
.consumption li :nth-child(1),
.charge li :nth-child(1),
.refund li :nth-child(1),
.unpaid li :nth-child(1){
    font-size: 0.42rem;
    position: absolute;
    top: 0.15rem;
    left: 0.55rem;
}
.all li :nth-child(2),
.consumption li :nth-child(2),
.charge li :nth-child(2),
.refund li :nth-child(2),
.unpaid li :nth-child(2){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0.85rem;
    left: 0.56rem;
}
.all li :nth-child(3),
.consumption li :nth-child(3),
.charge li :nth-child(3),
.refund li :nth-child(3),
.unpaid li :nth-child(3){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0.85rem;
    /* bottom: 0; */
    left: 4.68rem;
}
.all li :nth-child(4),
.consumption li :nth-child(4),
.charge li :nth-child(4),
.refund li :nth-child(4),
.unpaid li :nth-child(4){
    font-size: 0.37rem;
    color: rgba(41, 158, 173, 1);
    position: absolute;
    top: 0.37rem;
    right: 1.13rem;
}
.unpaid li :nth-child(4){
    color: rgba(246, 34, 65, 1);
}
.all li :nth-child(5),
.consumption li :nth-child(5),
.charge li :nth-child(5),
.refund li :nth-child(5),
.unpaid li :nth-child(5){
    width: 0.53rem;
    height: 0.53rem;
    position: absolute;
    top: 0.37rem;
    right: 0.34rem;
}
.vipLogo{
    width: 0.26rem;
    height: 0.26rem;
    position: absolute;
    top: 0.95rem;
    left: 1rem;
}
.redPoint{
    display: block;
    border-radius: 50%;
    width: 0.26rem;
    height: 0.26rem;
    background-color: rgba(246, 34, 65, 1);
    position: absolute;
    top: 0.29rem;
    left: 1rem;
}
.el-icon-arrow-right {
    font-size: 0.42rem;
    color: rgba(16, 16, 16, 1);
    font-weight: 600;
    position: absolute;
    top: 0.5rem;
    right: 0.51rem;
}

.info-custom {
    color: rgba(0, 0, 0, 0.35);
    font-size: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/consumption/consumptionHistory.vue